import React, { useState } from "react";
import { Col, Container, Card, Row, CardBody } from "reactstrap";
import DetailsModal from "./DetailsModal";

import Thumb1 from "../assets/images/portfolio/thumbs/01.jpg";
import Thumb2 from "../assets/images/portfolio/thumbs/02.jpg";
import Thumb3 from "../assets/images/portfolio/thumbs/03.jpg";
import Thumb4 from "../assets/images/portfolio/thumbs/04.jpg";
import Thumb5 from "../assets/images/portfolio/thumbs/05.jpg";
import Thumb6 from "../assets/images/portfolio/thumbs/06.jpg";
import Thumb7 from "../assets/images/portfolio/thumbs/07.jpg";

import HD1 from "../assets/images/portfolio/HD/01.jpg";
import HD2 from "../assets/images/portfolio/HD/02.jpg";
import HD3 from "../assets/images/portfolio/HD/03.jpg";
import HD4 from "../assets/images/portfolio/HD/04.jpg";
import HD5 from "../assets/images/portfolio/HD/05.jpg";
import HD6 from "../assets/images/portfolio/HD/06.jpg";
import HD7 from "../assets/images/portfolio/HD/07.jpg";

const caseStudies = [
  {
    image: Thumb4,
    highQualityImage: HD4,
    title: "CathLab Benchmarking and Efficiency Tool",
    context: [
      "Our client had launched a CathLab operational excellence offering as part of an integrated solution for interventional cardiology.",
      "Client had a Lean Six-sigma consulting team that performed various measurements and analytics using excel tools and datasets.",
      "This performance measurement approach was not scalable, prone to errors and resource intensive – global expansion was not feasible.",
    ],
    solution: [
      "We leveraged HCare360 platform to build a performance benchmarking and analytic tool with a user friendly interface.",
      "Tool included standard set of analytics (automated) and allowed users to run custom analysis.",
      "This tool was hosted on secure cloud, instantly updated and was accessible globally.",
      "We built AI/ML tools to check for data quality, and provide commentary and conclusions.",
    ],
    outcome: [
      "Client was successful in globally scaling the benchmarking tool.",
      "Tool eliminated all data quality issues, and reduced resource requirement by 80%.",
      "Client created additional revenue stream through monetizing the performance benchmarking offering.",
    ],
  },
  {
    image: Thumb3,
    highQualityImage: HD3,
    title: "Patient Screening and Identification Solution",
    context: [
      "Our client (a leading MedTech) had launched an innovative procedure to manage patients with Atrial fibrillation with a risk of stroke.",
      "However this approach was only beneficial for a sub-set of patients that could be identified with the help of specific scores (high CHADVAS / HASBLED scores).",
      "EMR and diagnostic data can yield to timely identification of these high risk patients.",
    ],
    solution: [
      "We developed a strategy for client to create a patient screening and identification solution.",
      "We leveraged HCare360 platform to automate data processing and create rule-based analytics to identify high risk atrial fibrillation patients based on CHADVAS/ HASBLED scores.",
      "Deployed a standardized messaging platform to securely transmit de-identified patient information into a cloud-based engine for running rule-based analytics.",
      "We supported client team to work with hospitals/clinics in driving implementation.",
    ],
    outcome: [
      "Client has successfully launched the solution in multiple EU markets.",
      "Successful in improving patient outcomes: Proactive identification of patients (e.g. Paroxysmal or persistent AF), Identify and intervene patients with risk for stroke, Uptake of device and procedure.",
    ],
  },
  {
    image: Thumb1,
    highQualityImage: HD1,
    title: "Demand Forecasting using Machine Learning",
    context: [
      "Client required more accurate and secure forecasts to estimate everchanging demand of its products.",
      "Reduce inventory of low-demand product and prevent depletion of high demand product stocks.",
      "Better Inventory management and more optimized cost.",
    ],
    solution: [
      "A robust Machine learning based forecasting model for estimating demands.",
      "Full automated ETL pipelines for onboarding supply chain data to cloud and perform data preparation thereafter.",
      "Detailed Data Analysis, Feature Engineering and Time series assessment.",
      "Deployed advanced Prophet Model for performing near accurate forecasts.",
      "The model accounted for general demand trends, seasonal variations, macroeconomic factors, Demand drivers amongst other things.",
    ],
    outcome: [
      "This system improved efficiency and optimised inventory balance resulting in better management of demands through the year.",
      "Improved workforce planning and reduction in the number of out-of-stock situations.",
      "Advantage over traditional forecasting models as ML based Prophet model allows to consider more variables thus tackle more uncertainties with lesser manual effort.",
    ],
  },
  {
    image: Thumb6,
    highQualityImage: HD6,
    title: "AI based Safety Stock Optimisation",
    context: [
      "Client has varied products and its own manufacturing plants so balance is desired between Make-To-Stock and Make-to-order operations.",
      "Over Stocking leads to high inventory cost and under stocking could lead to more lead times hence impacting customer satisfaction.",
      "An optimum safety stock levels was desired across products to ensure desired service level always.",
    ],
    solution: [
      "Quantify lead time and demand variances leveraging rolling window algorithms and used that as training dataset.",
      "A Well Tuned hybrid regression & random forest model build to optimize safety stock.",
      "Created an interactive report that shows the real time inventory, lead time of products, delays with indicators.",
    ],
    outcome: [
      "Lower inventory holding cost by 10-15% without compromising with the desired service level.",
      "Client was able to better assess decoupling point.",
      "Identify products with invariably high lead times and take remedial actions.",
    ],
  },
  {
    image: Thumb5,
    highQualityImage: HD5,
    title: "Delivery Route Optimisation",
    context: [
      "Client has a global supply chain network. It has several hundreds of shipments scheduled daily.",
      "Shipment is a major cost driver for supply chain and it can be optimized given the diverse set of product in terms of shape and size, multiple vendors involved with different delivery lines.",
      "Client wanted to optimise the transportation routes to cut down the delivery time and make the overall shipment operations more efficient and cost effective.",
    ],
    solution: [
      "A delivery optimizer model was recommended backed by detailed shipment data analysis. Historical data with information of routes, legs, delivery lines, container sizes etc. were studied and used for training model.",
      "During first phase weighted graph model was made with weighted nodes based on distance, pricing, fuel consumption, traffic, closeness of shipments etc.",
      "This was then optimised using sophisticated Neural networks and reinforcement learning algorithms.",
      "The model was integrated and deployed within existing system to ensure minimum impact to Business as usual.",
    ],
    outcome: [
      "Better Planned routes for future deliveries resulting in lesser turnaround time for deliveries.",
      "Efficient vendor management and reduction of shipping cost due to clustering of closely spaced destinations.",
      "More Nuanced commitments on deliveries hence enhancing end customer satisfaction.",
    ],
  },
  {
    image: Thumb2,
    highQualityImage: HD2,
    title: "Digital solutions in Radiology – Injector insights",
    context: [
      "Our client offers contrast media, auto injectors and software solutions for CT & MRI.",
      "The auto injectors collect large amounts of procedure related data and have remote connectivity via secure link.",
      "Our client was keen to offer value-added solutions to its customers and differentiate from competitors.",
    ],
    solution: [
      "We developed a strategy for client to create and monetize value added solutions.",
      "We leveraged HCare360 platform to build data analytic solutions incl. performance benchmarking and predictive maintenance etc. and deploy them globally.",
      "We supported client team to roll out the solution globally.",
    ],
    outcome: [
      "Client has successfully launched performance benchmarking for customers in US and EU.",
      "Chatbot for clinical and performance reporting.",
      "Predictive maintenance offered for selected customers.",
    ],
  },
  {
    image: Thumb7,
    highQualityImage: HD7,
    title: "Real time Reservoir monitoring",
    context: [
      "As the conventional petroleum resources are depleting, our client decided to move toward extraction of unconventional shale oil and gas through hydraulic fracturing of rocks.",
      "Real time insights were required to monitor the efficiency of this extraction processes to maximize the produced volume and reduce cost of production.",
      "The underlying idea is that a big fracture line consists of thousands of small fractures points emitting seismic data.",
    ],
    solution: [
      "A real time data processing model, that uses predictive analytics to locate the individual fracture points soon as they are created.",
      "It is a fully automated model that considers real time seismic data gathered by receivers, regional rock properties, previous data on similar geoprofile as training dataset.",
      "Through running several iterations based on simulated annealing and KNN algorithms, it brings out the most probable location of a fracture point.",
      "The locations would be shown on PowerBI for visualizing the depth of penetrations and monitor the live growth of fractures.",
    ],
    outcome: [
      "Client was able to achieve better cost optimisation as with the real-time insights, instant enhancement and remedial actions could be taken.",
      "With a better understanding of reservoir characteristics, rock properties they were able to design more cost optimized drilling and extraction plans for future borewells.",
    ],
  },
];

export default function CaseStudies() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});

  const handleCardClick = (cs) => {
    setModalData({
      title: cs.title,
      image: cs.image,
      highQualityImage: cs.highQualityImage,
      sections: [
        { heading: "Context", content: cs.context },
        { heading: "Our Solution", content: cs.solution },
        { heading: "Outcome", content: cs.outcome },
      ],
    });
    setModalOpen(true);
  };

  return (
    <>
      {/* Start Case Studies  */}
      <section className="section bg-light" id="case-studies">
        <Container>
          <Row className="justify-content-center">
            <Col>
              <div className="section-title text-center mb-4 pb-2">
                <h4 className="title mb-3">Case Studies</h4>
                <p className="text-muted para-desc mb-0 mx-auto">
                  Explore our real-world impact through these selected case
                  studies.
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            {caseStudies.map((cs, idx) => (
              <Col lg={6} md={12} className="mt-4 pt-2" key={idx}>
                <Card
                  className="shadow rounded overflow-hidden border-0 mb-4"
                  onClick={() => handleCardClick(cs)}
                  style={{ cursor: "pointer" }}
                >
                  <Row className="g-0 align-items-center">
                    <Col md={5} className="p-0">
                      <img
                        src={cs.image}
                        className="img-fluid w-100 h-100 object-fit-cover"
                        alt={cs.title}
                      />
                    </Col>
                    <Col md={7} className="p-0">
                      <CardBody className="content p-4">
                        <h5 className="title text-dark mb-2">{cs.title}</h5>
                        <p className="text-muted mb-0">
                          Click to view full case study
                        </p>
                      </CardBody>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      {/* End Case Studies  */}
      <DetailsModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        {...modalData}
      />
    </>
  );
}
